import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  PostAcceptOrRejectAppointment,
  getCancelledReqWithDate,
  getClinicAppointrequestAccepted,
  getClinicAppointrequestCancelled,
  getClinicPastAppointments,
  getClinicPastRequestWithDate,
  getClinicTodayAppointmentRequests,
  getClinicUpcomingAppointmentRequests,
  getUpcomingReqWithDate,
} from "../../services/clinicOnboarding";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Loader";
import "../../styles/ClinicTables.scss";
import { useContext } from "react";
import { Permissions } from "../Context/PermissionsContext";
import moment from "moment";
import { getUnattendedAppointmentRequestData } from "../../services/customerOnboarding";

export const ClinicTodayTable = () => {
  const [clinicTodayData, setClinicTodayData] = useState([]);
  const token = JSON.parse(localStorage.getItem("token"));
  const uniqueId = token.uniqueId;
  const [acceptReject, setAcceptReject] = useState(false);
  const [rejectopen, setRejectOpen] = useState(false);
  const [itemId, setItemid] = useState("");
  const navigate = useNavigate();
  const { permissionsData, loading, setLoading } = useContext(Permissions);
  let clinicPermissionsModule = permissionsData?.filter(
    (item) => item.module === "appointment"
  );
  let clinicPermissions =
    clinicPermissionsModule && clinicPermissionsModule[0]?.permissions;
  // console.log("clinicpermissions",clinicPermissions);
  let TodayPermission = clinicPermissions?.find(
    (item) => item.action === "Today"
  )?.permission;
  let OpenAppointmentPermission = clinicPermissions?.find(
    (item) => item.action === "Open Appointment"
  )?.permission;
  // let OpenAppointmentPermission=false
  let CancelAppointmentPermission = clinicPermissions?.find(
    (item) => item.action === "Cancel Appointment"
  )?.permission;

  // let TodayPermission=false
  console.log("todaypermissions", TodayPermission);
  const getClinicTodayData = async () => {
    setLoading(true);
    try {
      const response = await getClinicTodayAppointmentRequests(uniqueId);
      console.log(response.data);
      const data = response.data;
      const sortedData = data.sort((a, b) => {
        const timeA = a.time.split(" - ")[0];
        const timeB = b.time.split(" - ")[0];
        return (
          new Date(`1970/01/01 ${timeA}`) - new Date(`1970/01/01 ${timeB}`)
        );
      });
      let newdata = sortedData.map((el) => {
        el.time = modifiedTime(el.time);
        function modifiedTime(timing) {
          const parts = timing.split(" - ");
          const startTime = parts[0];
          const endTime = parts[1];

          // Converting start time to 12-hour format
          const start = new Date(`2000-01-01T${startTime}`);
          const startHours = start.getHours();
          const startMinutes = start.getMinutes();
          const formattedStartTime = `${startHours % 12 || 12}:${startMinutes
            .toString()
            .padStart(2, "0")}`;

          // Converting end time to 12-hour format
          const end = new Date(`2000-01-01T${endTime}`);
          const endHours = end.getHours();
          const endMinutes = end.getMinutes();
          const formattedEndTime = `${endHours % 12 || 12}:${endMinutes
            .toString()
            .padStart(2, "0")}`;

          // Determine AM/PM
          const amPm = startHours < 12 ? "AM" : "PM";

          return `${formattedStartTime} ${amPm} - ${formattedEndTime} ${amPm}`;
        }
        return el;
      });
      console.log("today clinic new data", newdata);
      setClinicTodayData(newdata);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleRejectdialogOpen = (id) => {
    console.log("rejectid", id);
    setRejectOpen(true);
    setItemid(id);
  };
  const handleRejectDialogClose = () => {
    setRejectOpen(false);
    setAcceptReject(false);
  };
  const error = () => {
    toast.success("Cancelled Successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const handleReject = async (id) => {
    const Rejectdata = {
      id: id,
      response: "Rejected",
      updatedBy: token.username,
    };
    // console.log("Rejected data.........",Rejectdata)
    try {
      await PostAcceptOrRejectAppointment(Rejectdata);
      console.log("Rejected data post success..");
      setAcceptReject(true);
      error();
    } catch (error) {
      console.log(error.message);
    }
  };

  const formattedDate = (date) => {
    const dob = moment(date);
    const formattedDob = dob.format("DD-MM-YYYY");
    return formattedDob;
  };

  useEffect(() => {
    getClinicTodayData();
    console.log("clinictodaydata", clinicTodayData);
  }, [acceptReject]);

  if (loading)
    return (
      <>
        <Loader />
      </>
    );
  return (
    <Box>
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "1px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
          boxShadow: "none",
        }}
        className="desktopscreencard"
      >
        {clinicTodayData.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Typography variant="h6" color="textSecondary">
              No today appointments
            </Typography>
          </div>
        ) : (
          <>
            {clinicTodayData.map((el, id) => {
              return (
                <>
                  {TodayPermission && (
                    <Card
                      sx={{
                        padding: "0px 0%!important",
                        marginBottom: "10px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "5px",
                        boxShadow: "none",
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={2.5}>
                          <Box
                            sx={{
                              padding: "15px",
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#D83F87",
                                fontWeight: "bold",
                                fontSize: "10px",
                              }}
                            >
                              Appointment ID
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold", fontSize: "12px" }}
                            >
                              {el.appointmentId}
                            </Typography>
                            {/* <Box
                  style={{
                    background: "#00984F",
                    padding: "10px",
                    borderRadius: "6px",
                    lineHeight: "0.5",
                  }}
                >
                  <Typography variant="caption" sx={{ color: "#fff" }}>
                    {el.request}
                  </Typography>
                </Box> */}
                            <Box>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#D83F87",
                                  fontWeight: "bold",
                                  fontSize: "10px",
                                }}
                              >
                                Appointment Status
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "bold", fontSize: "12px" }}
                              >
                                {el.appointmentStatus}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}
                        <Grid item xs={7.5}>
                          <Grid container spacing={1}>
                            <Grid item xs={4}>
                              <Box sx={{ padding: "15px" }}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: "bold", fontSize: "12px" }}
                                >
                                  {el.patientName}
                                </Typography>
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <PhoneIcon style={{ fontSize: "12px" }} />
                                  <Typography
                                    variant="caption"
                                    sx={{ fontSize: "12px" }}
                                  >
                                    {el.patientNumber}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "10px",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  {/* <Typography
                        variant="caption"
                        sx={{
                          color: "#D83F87",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {el.location}
                      </Typography> */}
                                  {/* <Typography
                        variant="caption"
                        sx={{
                          color: "#D83F87",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {el.customernumber}
                      </Typography> */}
                                </Box>
                                <Box sx={{ textAlign: "center", width: "70%" }}>
                                  <Typography
                                    sx={{
                                      fontSize: "10px",
                                      background: "#FFEFF9",
                                      padding: "5px",
                                      color: "gray",
                                      borderRadius: "6px",
                                      width: "100%",
                                    }}
                                  >
                                    {el.specialty}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box sx={{ padding: "15px" }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "#D83F87",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                  }}
                                >
                                  Appointment Date
                                </Typography>
                                <Typography
                                  v4ant="subtitle1"
                                  sx={{ fontWeight: "bold", fontSize: "12px" }}
                                >
                                  {formattedDate(el.date)}
                                </Typography>
                                <Box sx={{ marginTop: "15px" }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#D83F87",
                                      fontWeight: "bold",
                                      fontSize: "10px",
                                    }}
                                  >
                                    Appointment Time
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {el.time}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>

                            <Grid item xs={4}>
                              <Box
                                sx={{
                                  padding: "15px",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "#D83F87",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                  }}
                                >
                                  Remarks
                                </Typography>{" "}
                                <br />
                                <Typography
                                  variant="caption"
                                  sx={{ fontSize: "12px" }}
                                >
                                  {el.remark}
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}

                        <Grid item xs={2} sx={{ backgroundColor: "#F5F5F5" }}>
                          <Grid
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              paddingTop: "25px",
                            }}
                            container
                          >
                            {OpenAppointmentPermission && (
                              <button
                                style={{
                                  background: "#D83F87",
                                  textAlign: "left",
                                  border: "none",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  color: "#fff",
                                  padding: "8px 15px",
                                  marginBottom: "10px",
                                  width: "65%",
                                  fontSize: "12px",
                                  alignItems: "center",
                                  display: "flex",
                                  gap: "5px",
                                }}
                                onClick={() => {
                                  if (el.appointmentStatus === "Completed") {
                                    navigate(
                                      `/user/pastappointmentinformation/${el.appointmentId}`
                                    );
                                  } else {
                                    navigate(
                                      `/user/appointmentinformation/${el.id}`
                                    );
                                  }
                                }}
                              >
                                <CalendarMonthIcon
                                  style={{ fontSize: "0.9rem" }}
                                />{" "}
                                Open
                              </button>
                            )}
                            <br />
                            {CancelAppointmentPermission &&
                              el.appointmentStatus === "Accepted" && (
                                <button
                                  style={{
                                    background: "#3E2732",
                                    border: "none",
                                    textAlign: "left",
                                    alignItems: "center",
                                    borderRadius: "3px",
                                    cursor: "pointer",
                                    color: "#fff",
                                    padding: "8px 15px",
                                    fontSize: "12px",
                                    width: "65%",
                                    display: "flex",
                                    gap: "5px",
                                  }}
                                  onClick={() => {
                                    handleRejectdialogOpen(el.id);
                                    console.log("reject id........ ", el.id);
                                  }}
                                >
                                  <CancelPresentationIcon
                                    style={{ fontSize: "0.9rem" }}
                                  />{" "}
                                  Cancel
                                </button>
                              )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                </>
              );
            })}
          </>
        )}
      </Card>

      {/* -------------------------Dialog box for Reject---------------------- */}
      <Dialog
        open={rejectopen}
        onClose={handleRejectDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to Reject ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            sx={{
              backgroundColor: "#D83F87",
              textAlign: "center",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": { backgroundColor: "#D83F87!important" },
            }}
            onClick={() => {
              handleReject(itemId);
              handleRejectDialogClose();
            }}
            autoFocus
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#2d256c",
              textAlign: "center",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": { backgroundColor: "#2d256c!important" },
            }}
            onClick={handleRejectDialogClose}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* ----------------------------------Table for mobile screen--------------------------- */}
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "1px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
          boxShadow: "none",
        }}
        className="mobilescreencard"
      >
        {clinicTodayData.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Typography variant="h6" color="textSecondary">
              No today appointments
            </Typography>
          </div>
        ) : (
          <>
            {clinicTodayData.map((el, id) => {
              return (
                <>
                  {TodayPermission && (
                    <Card
                      sx={{
                        padding: "0px 0%!important",
                        marginBottom: "10px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "5px",
                        boxShadow: "none",
                      }}
                      className="mobilecontentcard"
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <Typography className="appointmentid" variant="h6">
                            {el.appointmentId}
                          </Typography>
                          <Typography className="dateheading" variant="caption">
                            Date
                          </Typography>
                          <Typography className="date" variant="subtitle1">
                            {formattedDate(el.date)}
                          </Typography>
                          <Typography className="dateheading" variant="caption">
                            Status:{" "}
                            <span className="date">{el.appointmentStatus}</span>
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="speciality">
                            {el.specialty}
                          </Typography>
                          <Typography variant="caption" className="timeheading">
                            Time
                          </Typography>
                          <Typography variant="subtitle1" className="time">
                            {el.time}
                          </Typography>
                        </Grid>
                        <Grid
                          sx={{ backgroundColor: "#F5F5F5!important" }}
                          item
                          xs={4}
                        >
                          {OpenAppointmentPermission && (
                            <button
                              onClick={() => {
                                if (el.appointmentStatus === "Completed") {
                                  navigate(
                                    `/user/pastappointmentinformation/${el.appointmentId}`
                                  );
                                } else {
                                  navigate(
                                    `/user/appointmentinformation/${el.id}`
                                  );
                                }
                              }}
                              style={{
                                background: "#D83F87",
                                textAlign: "left",
                                border: "none",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "#fff",
                                padding: "5px 10px",
                                marginBottom: "10px",
                                width: "90%",
                                fontSize: "10px",
                                alignItems: "center",
                                display: "flex",
                                gap: "5px",
                              }}
                              className="openbtn"
                            >
                              <CalendarMonthIcon style={{ fontSize: "14px" }} />{" "}
                              Open
                            </button>
                          )}
                          {CancelAppointmentPermission &&
                            el.appointmentStatus === "Accepted" && (
                              <button
                                style={{
                                  background: "#3E2732",
                                  border: "none",
                                  textAlign: "left",
                                  alignItems: "center",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  color: "#fff",
                                  padding: "5px 10px",
                                  fontSize: "10px",
                                  width: "90%",
                                  display: "flex",
                                  gap: "5px",
                                }}
                                onClick={() => {
                                  handleRejectdialogOpen(el.id);
                                  console.log("reject id........ ", el.id);
                                }}
                              >
                                <CancelPresentationIcon
                                  style={{ fontSize: "14px" }}
                                />{" "}
                                Cancel
                              </button>
                            )}
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                </>
              );
            })}
          </>
        )}
      </Card>
    </Box>
  );
};

// ---------------------------upcoming-----------------------

export const ClinicUpcomingTable = ({
  calenderOpen,
  setAcceptedUpcoming,
  acceptedUpcoming,
  newSelectDate,
}) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const uniqueId = token.uniqueId;
  const [acceptReject, setAcceptReject] = useState(false);
  const [rejectopen, setRejectOpen] = useState(false);
  const [itemId, setItemid] = useState("");
  // console.log(acceptedUpcoming);
  const { permissionsData, loading, setLoading } = useContext(Permissions);
  let clinicPermissionsModule = permissionsData?.filter(
    (item) => item.module === "appointment"
  );
  let clinicPermissions =
    clinicPermissionsModule && clinicPermissionsModule[0]?.permissions;
  // console.log("clinicpermissions",clinicPermissions);
  let UpcomingPermission = clinicPermissions?.find(
    (item) => item.action === "Upcoming"
  )?.permission;
  let CancelAppointmentPermission = clinicPermissions?.find(
    (item) => item.action === "Cancel Appointment"
  )?.permission;

  // let TodayPermission=false

  async function getAppointmentUpcomingData() {
    setLoading(true);
    try {
      const response = await getClinicUpcomingAppointmentRequests(uniqueId);
      // console.log(response.data)
      const data = response.data;
      let sortedData = data.sort((a, b) => {
        // Sort by date (descending)
        if (a.date > b.date) return -1;
        if (a.date < b.date) return 1;

        // Sort by time (ascending)
        const timeA = a.time.split(" - ")[0];
        const timeB = b.time.split(" - ")[0];
        return (
          new Date(`1970/01/01 ${timeA}`) - new Date(`1970/01/01 ${timeB}`)
        );
      });
      let newdata = sortedData.map((el) => {
        el.time = modifiedTime(el.time);
        function modifiedTime(timing) {
          const parts = timing.split(" - ");
          const startTime = parts[0];
          const endTime = parts[1];

          // Converting start time to 12-hour format
          const start = new Date(`2000-01-01T${startTime}`);
          const startHours = start.getHours();
          const startMinutes = start.getMinutes();
          const formattedStartTime = `${startHours % 12 || 12}:${startMinutes
            .toString()
            .padStart(2, "0")}`;

          // Converting end time to 12-hour format
          const end = new Date(`2000-01-01T${endTime}`);
          const endHours = end.getHours();
          const endMinutes = end.getMinutes();
          const formattedEndTime = `${endHours % 12 || 12}:${endMinutes
            .toString()
            .padStart(2, "0")}`;

          // Determine AM/PM
          const amPm = startHours < 12 ? "AM" : "PM";

          return `${formattedStartTime} ${amPm} - ${formattedEndTime} ${amPm}`;
        }
        return el;
      });
      console.log("newdata response with time..", newdata);
      if (newdata) {
        setAcceptedUpcoming(newdata);
        setAcceptReject(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  const handleRejectdialogOpen = (id) => {
    console.log("rejectid", id);
    setRejectOpen(true);
    setItemid(id);
  };
  const handleRejectDialogClose = () => {
    setRejectOpen(false);
    setAcceptReject(false);
  };
  const error = () => {
    toast.success("Cancelled Successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const handleReject = async (id) => {
    const Rejectdata = {
      id: id,
      response: "Rejected",
      updatedBy: token.username,
    };
    // console.log("Rejected data.........",Rejectdata)
    try {
      await PostAcceptOrRejectAppointment(Rejectdata);
      console.log("Rejected data post success..");
      setAcceptReject(true);
      error();
    } catch (error) {
      console.log(error.message);
    }
  };

  // useEffect(() => {
  //   getAppointmentUpcomingData();
  //   if(newSelectDate!==null){
  //     try {
  //       let response=await getUpcomingReqWithDate(newSelectDate,uniqueId)
  //       let data=response.data;
  //       console.log("upcomingreq with data",data)
  //       setAcceptedUpcoming(data)
  //     } catch (error) {
  //       console.log(error.message)
  //     }
  //   }
  // }, [acceptReject]);

  const formattedDate = (date) => {
    const dob = moment(date);
    const formattedDob = dob.format("DD-MM-YYYY");
    return formattedDob;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await getUpcomingReqWithDate(newSelectDate, uniqueId);
        let data = response.data;
        console.log("upcomingreq with data", data);
        setAcceptedUpcoming(data);
      } catch (error) {
        console.log(error.message);
      }
    };

    if (newSelectDate) {
      fetchData();
    } else {
      getAppointmentUpcomingData();
    }
  }, [acceptReject, newSelectDate]);

  if (loading)
    return (
      <h1>
        <Loader />
      </h1>
    );
  return (
    <>
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "1px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
          boxShadow: "none",
        }}
        className="thecardbox"
      >
        {acceptedUpcoming.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Typography variant="h6" color="textSecondary">
              No Upcoming appointments
            </Typography>
          </div>
        ) : (
          <>
            {acceptedUpcoming.map((el, id) => {
              return (
                <>
                  {UpcomingPermission && (
                    <Card
                      sx={{
                        padding: "0px 0%!important",
                        marginBottom: "10px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "5px",
                        boxShadow: "none",
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={3}>
                          <Box
                            sx={{
                              padding: "15px",
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#D83F87",
                                fontWeight: "bold",
                                fontSize: "10px",
                              }}
                            >
                              Appointment ID
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold", fontSize: "12px" }}
                            >
                              {el.appointmentId == null ? (
                                <>No Appointment ID</>
                              ) : (
                                el.appointmentId
                              )}
                            </Typography>
                            {/* <Box
                  style={{
                    background: "#00984F",
                    padding: "10px",
                    borderRadius: "6px",
                    lineHeight: "0.5",
                  }}
                >
                  <Typography variant="caption" sx={{ color: "#fff" }}>
                    {el.request}
                  </Typography>
                </Box> */}
                            <Box>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#D83F87",
                                  fontWeight: "bold",
                                  fontSize: "10px",
                                }}
                              >
                                Appointment Status
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "bold", fontSize: "12px" }}
                              >
                                {el.appointmentStatus}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}
                        <Grid item xs={7}>
                          <Grid container spacing={1}>
                            <Grid item xs={4}>
                              <Box sx={{ padding: "15px" }}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: "bold", fontSize: "12px" }}
                                >
                                  {el.patientName}
                                </Typography>
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <PhoneIcon style={{ fontSize: "12px" }} />
                                  <Typography
                                    variant="caption"
                                    sx={{ fontSize: "12px" }}
                                  >
                                    {el.patientNmber === null ? (
                                      <>No number</>
                                    ) : (
                                      el.patientNumber
                                    )}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "10px",
                                    paddingLeft: "20px",
                                  }}
                                ></Box>
                                <Box sx={{ textAlign: "center", width: "70%" }}>
                                  <Typography
                                    sx={{
                                      fontSize: "10px",
                                      background: "#FFEFF9",
                                      padding: "5px",
                                      color: "gray",
                                      borderRadius: "6px",
                                      width: "100%",
                                    }}
                                  >
                                    {el.specialty}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={5}>
                              <Box sx={{ padding: "15px" }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "#D83F87",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                  }}
                                >
                                  Appointment Date
                                </Typography>
                                <Typography
                                  v4ant="subtitle1"
                                  sx={{ fontWeight: "bold", fontSize: "12px" }}
                                >
                                  {formattedDate(el.date)}
                                </Typography>
                                <Box sx={{ marginTop: "15px" }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#D83F87",
                                      fontWeight: "bold",
                                      fontSize: "10px",
                                    }}
                                  >
                                    Appointment Time
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {el.time}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>

                            <Grid item xs={3}>
                              <Box
                                sx={{
                                  padding: "15px",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "#D83F87",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                  }}
                                >
                                  Remarks
                                </Typography>{" "}
                                <br />
                                <Typography
                                  variant="caption"
                                  sx={{ fontSize: "12px" }}
                                >
                                  {el.remark === "" ? (
                                    <>No Remarks</>
                                  ) : (
                                    el.remark
                                  )}
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}

                        <Grid item xs={2} sx={{ backgroundColor: "#F5F5F5" }}>
                          <Grid
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              paddingTop: "45px",
                            }}
                            container
                          >
                            {CancelAppointmentPermission && (
                              <button
                                style={{
                                  background: "#3E2732",
                                  border: "none",
                                  textAlign: "left",
                                  alignItems: "center",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                  color: "#fff",
                                  padding: "8px 15px",
                                  fontSize: "12px",
                                  width: "65%",
                                  display: "flex",
                                  gap: "5px",
                                }}
                                onClick={() => {
                                  handleRejectdialogOpen(el.id);
                                  console.log("reject id........ ", el.id);
                                }}
                              >
                                <CancelPresentationIcon
                                  style={{ fontSize: "0.9rem" }}
                                />{" "}
                                Cancel
                              </button>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                </>
              );
            })}
          </>
        )}
      </Card>

      {/* -------------------------Dialog box for Reject---------------------- */}
      <Dialog
        open={rejectopen}
        onClose={handleRejectDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to Reject ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            sx={{
              backgroundColor: "#D83F87",
              textAlign: "center",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": { backgroundColor: "#D83F87!important" },
            }}
            onClick={() => {
              handleReject(itemId);
              handleRejectDialogClose();
            }}
            autoFocus
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#2d256c",
              textAlign: "center",
              color: "#FFFFFF",
              textTransform: "capitalize",
              "&:hover": { backgroundColor: "#2d256c!important" },
            }}
            onClick={handleRejectDialogClose}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* ----------------------------------Table for mobile screen--------------------------- */}
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "1px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
          boxShadow: "none",
        }}
        className="mobilescreencard"
      >
        {acceptedUpcoming.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Typography variant="h6" color="textSecondary">
              No Upcoming appointments
            </Typography>
          </div>
        ) : (
          <>
            {acceptedUpcoming.map((el, id) => {
              return (
                <>
                  {UpcomingPermission && (
                    <Card
                      sx={{
                        padding: "0px 0%!important",
                        marginBottom: "10px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "5px",
                        boxShadow: "none",
                      }}
                      className="mobilecontentcard"
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <Typography className="appointmentid" variant="h6">
                            {el.appointmentId}
                          </Typography>
                          <Typography className="dateheading" variant="caption">
                            Date
                          </Typography>
                          <Typography className="date" variant="subtitle1">
                            {formattedDate(el.date)}
                          </Typography>
                          <Typography className="dateheading" variant="caption">
                            Status:{" "}
                            <span className="date">{el.appointmentStatus}</span>
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="speciality">
                            {el.specialty}
                          </Typography>
                          <Typography variant="caption" className="timeheading">
                            Time
                          </Typography>
                          <Typography variant="subtitle1" className="time">
                            {el.time}
                          </Typography>
                        </Grid>
                        <Grid
                          sx={{ backgroundColor: "#F5F5F5!important" }}
                          item
                          xs={4}
                        >
                          {CancelAppointmentPermission && (
                            <button
                              style={{
                                background: "#3E2732",
                                border: "none",
                                textAlign: "left",
                                alignItems: "center",
                                borderRadius: "3px",
                                cursor: "pointer",
                                color: "#fff",
                                padding: "5px 10px",
                                fontSize: "10px",
                                width: "90%",
                                display: "flex",
                                gap: "5px",
                              }}
                              className="cancelbtn"
                              onClick={() => {
                                handleRejectdialogOpen(el.id);
                                console.log("reject id........ ", el.id);
                              }}
                            >
                              <CancelPresentationIcon
                                style={{ fontSize: "14px" }}
                              />{" "}
                              Cancel
                            </button>
                          )}
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                </>
              );
            })}
          </>
        )}
      </Card>
    </>
  );
};

// --------------------------------clinic past-------------------------------------

export const ClinicPastTable = ({
  clinicPastAppointments,
  setClinicPastAppointments,
  newPastSelectedDate,
}) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const uniqueId = token.uniqueId;
  const [itemId, setItemid] = useState("");
  const navigate = useNavigate();
  const { permissionsData, loading, setLoading } = useContext(Permissions);
  let clinicPermissionsModule = permissionsData?.filter(
    (item) => item.module === "appointment"
  );
  let clinicPermissions =
    clinicPermissionsModule && clinicPermissionsModule[0]?.permissions;
  // console.log("clinicpermissions",clinicPermissions);
  let PastPermission = clinicPermissions?.find(
    (item) => item.action === "Past"
  )?.permission;
  let OpenAppointmentPermission = clinicPermissions?.find(
    (item) => item.action === "Open Appointment"
  )?.permission;

  // let TodayPermission=false

  const getClinicPastData = async () => {
    setLoading(true);
    try {
      const response = await getClinicPastAppointments(uniqueId);
      // console.log(response.data)
      const data = response.data;
      let sortedData = data.sort((a, b) => {
        // Sort by date (descending)
        if (a.date > b.date) return -1;
        if (a.date < b.date) return 1;

        // Sort by time (ascending)
        const timeA = a.time.split(" - ")[0];
        const timeB = b.time.split(" - ")[0];
        return (
          new Date(`1970/01/01 ${timeB}`) - new Date(`1970/01/01 ${timeA}`)
        );
      });
      let newdata = sortedData.map((el) => {
        el.time = modifiedTime(el.time);
        function modifiedTime(timing) {
          const parts = timing.split(" - ");
          const startTime = parts[0];
          const endTime = parts[1];

          // Converting start time to 12-hour format
          const start = new Date(`2000-01-01T${startTime}`);
          const startHours = start.getHours();
          const startMinutes = start.getMinutes();
          const formattedStartTime = `${startHours % 12 || 12}:${startMinutes
            .toString()
            .padStart(2, "0")}`;

          // Converting end time to 12-hour format
          const end = new Date(`2000-01-01T${endTime}`);
          const endHours = end.getHours();
          const endMinutes = end.getMinutes();
          const formattedEndTime = `${endHours % 12 || 12}:${endMinutes
            .toString()
            .padStart(2, "0")}`;

          // Determine AM/PM
          const amPm = startHours < 12 ? "AM" : "PM";

          return `${formattedStartTime} ${amPm} - ${formattedEndTime} ${amPm}`;
        }
        return el;
      });
      console.log("newdata response with time..", newdata);
      if (newdata) {
        setClinicPastAppointments(newdata);
        setLoading(false);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const formattedDate = (date) => {
    const dob = moment(date);
    const formattedDob = dob.format("DD-MM-YYYY");
    return formattedDob;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await getClinicPastRequestWithDate(
          newPastSelectedDate,
          uniqueId
        );
        let data = response.data;
        console.log("upcomingreq with data", data);
        setClinicPastAppointments(data);
      } catch (error) {
        console.log(error.message);
      }
    };

    if (newPastSelectedDate) {
      fetchData();
    } else {
      getClinicPastData();
    }
  }, [newPastSelectedDate]);
  if (loading)
    return (
      <>
        <Loader />
      </>
    );
  return (
    <>
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "1px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
          boxShadow: "none",
        }}
        className="desktopscreencard"
      >
        {clinicPastAppointments.map((el, id) => {
          return (
            <>
              <Card
                sx={{
                  padding: "0px 0%!important",
                  marginBottom: "10px",
                  border: "1px solid #D9D9D9",
                  borderRadius: "5px",
                  boxShadow: "none",
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={2.5}>
                    <Box
                      sx={{
                        padding: "15px",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#D83F87",
                          fontWeight: "bold",
                          fontSize: "10px",
                        }}
                      >
                        Appointment ID
                      </Typography>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", fontSize: "12px" }}
                      >
                        {el.appointmentId}
                      </Typography>
                      {/* <Box
                  style={{
                    background: "#00984F",
                    padding: "10px",
                    borderRadius: "6px",
                    lineHeight: "0.5",
                  }}
                >
                  <Typography variant="caption" sx={{ color: "#fff" }}>
                    {el.request}
                  </Typography>
                </Box> */}
                    </Box>
                  </Grid>
                  {/* <Divider orientation="vertical" flexItem /> */}
                  <Grid item xs={7.5}>
                    <Grid container spacing={1}>
                      <Grid item xs={4}>
                        <Box sx={{ padding: "15px" }}>
                          <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: "bold", fontSize: "12px" }}
                          >
                            {el.patientName}
                          </Typography>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <PhoneIcon style={{ fontSize: "12px" }} />
                            <Typography
                              variant="caption"
                              sx={{ fontSize: "12px" }}
                            >
                              {el.patientNumber}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              gap: "10px",
                              paddingLeft: "20px",
                            }}
                          >
                            {/* <Typography
                        variant="caption"
                        sx={{
                          color: "#D83F87",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {el.location}
                      </Typography> */}
                            {/* <Typography
                        variant="caption"
                        sx={{
                          color: "#D83F87",
                          fontSize: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {el.customernumber}
                      </Typography> */}
                          </Box>
                          <Box sx={{ textAlign: "center", width: "70%" }}>
                            <Typography
                              sx={{
                                fontSize: "10px",
                                background: "#FFEFF9",
                                padding: "5px",
                                color: "gray",
                                borderRadius: "6px",
                                width: "100%",
                              }}
                            >
                              {el.specialty}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box sx={{ padding: "15px" }}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#D83F87",
                              fontWeight: "bold",
                              fontSize: "10px",
                            }}
                          >
                            Appointment Date
                          </Typography>
                          <Typography
                            v4ant="subtitle1"
                            sx={{ fontWeight: "bold", fontSize: "12px" }}
                          >
                            {formattedDate(el.date)}
                          </Typography>
                          <Box sx={{ marginTop: "15px" }}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#D83F87",
                                fontWeight: "bold",
                                fontSize: "10px",
                              }}
                            >
                              Appointment Time
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "bold", fontSize: "12px" }}
                            >
                              {el.time}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={4}>
                        <Box
                          sx={{
                            padding: "15px",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#D83F87",
                              fontWeight: "bold",
                              fontSize: "10px",
                            }}
                          >
                            Remarks
                          </Typography>{" "}
                          <br />
                          <Typography
                            variant="caption"
                            sx={{ fontSize: "12px" }}
                          >
                            {el.remark}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Divider orientation="vertical" flexItem /> */}

                  <Grid item xs={2} sx={{ backgroundColor: "#F5F5F5" }}>
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "45px",
                      }}
                      container
                    >
                      {OpenAppointmentPermission && (
                        <button
                          style={{
                            background: "#D83F87",
                            textAlign: "left",
                            border: "none",
                            borderRadius: "3px",
                            cursor: "pointer",
                            color: "#fff",
                            padding: "8px 15px",
                            marginBottom: "10px",
                            width: "65%",
                            fontSize: "12px",
                            alignItems: "center",
                            display: "flex",
                            gap: "5px",
                          }}
                          onClick={() =>
                            navigate(
                              `/user/pastappointmentinformation/${el.appointmentId}`
                            )
                          }
                        >
                          <CalendarMonthIcon style={{ fontSize: "0.9rem" }} />{" "}
                          Open
                        </button>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </>
          );
        })}
      </Card>

      {/* ----------------------------------Table for mobile screen--------------------------- */}
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "1px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
          boxShadow: "none",
        }}
        className="mobilescreencard"
      >
        {clinicPastAppointments.map((el, id) => {
          return (
            <>
              <Card
                sx={{
                  padding: "0px 0%!important",
                  marginBottom: "10px",
                  border: "1px solid #D9D9D9",
                  borderRadius: "5px",
                  boxShadow: "none",
                }}
                className="mobilecontentcard"
              >
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Typography className="appointmentid" variant="h6">
                      {el.appointmentId}
                    </Typography>
                    <Typography className="dateheading" variant="caption">
                      Date
                    </Typography>
                    <Typography className="date" variant="subtitle1">
                      {formattedDate(el.date)}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="speciality">
                      {el.specialty}
                    </Typography>
                    <Typography variant="caption" className="timeheading">
                      Time
                    </Typography>
                    <Typography variant="subtitle1" className="time">
                      {el.time}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{ backgroundColor: "#F5F5F5!important" }}
                    item
                    xs={4}
                  >
                    {OpenAppointmentPermission && (
                      <button
                        onClick={() =>
                          navigate(
                            `/user/pastappointmentinformation/${el.appointmentId}`
                          )
                        }
                        style={{
                          background: "#D83F87",
                          textAlign: "left",
                          border: "none",
                          borderRadius: "3px",
                          cursor: "pointer",
                          color: "#fff",
                          padding: "5px 10px",
                          marginBottom: "10px",
                          marginTop: "15px",
                          width: "90%",
                          fontSize: "10px",
                          alignItems: "center",
                          display: "flex",
                          gap: "5px",
                        }}
                        className="openbtn"
                      >
                        <CalendarMonthIcon style={{ fontSize: "14px" }} /> Open
                      </button>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </>
          );
        })}
      </Card>
    </>
  );
};

// ----------------------------clinic cancelled-----------------------

// export const ClinicCancelledTable = ({
//   calenderOpen,
//   setCancelledAppointments,
//   cancelledAppointments,
//   newCancelSelectedDate,
// }) => {
//   const token = JSON.parse(localStorage.getItem("token"));
//   const uniqueId = token.uniqueId;
//   const [acceptReject, setAcceptReject] = useState(false);
//   console.log(cancelledAppointments);
//   const { permissionsData, loading, setLoading } = useContext(Permissions);
//   let clinicPermissionsModule = permissionsData?.filter(
//     (item) => item.module === "appointment"
//   );
//   let clinicPermissions =
//     clinicPermissionsModule && clinicPermissionsModule[0]?.permissions;
//   // console.log("clinicpermissions",clinicPermissions);
//   let CancelledPermission = clinicPermissions?.find(
//     (item) => item.action === "Cancelled"
//   )?.permission;
//   // let TodayPermission=false

//   async function getAppointmentCancelledData() {
//     setLoading(true);
//     try {
//       const response = await getClinicAppointrequestCancelled(uniqueId);
//       // console.log(response.data)
//       const data = response.data;
//       let sortedData = data.sort((a, b) => {
//         // Sort by date (descending)
//         if (a.date > b.date) return -1;
//         if (a.date < b.date) return 1;

//         // Sort by time (ascending)
//         const timeA = a.time.split(" - ")[0];
//         const timeB = b.time.split(" - ")[0];
//         return (
//           new Date(`1970/01/01 ${timeB}`) - new Date(`1970/01/01 ${timeA}`)
//         );
//       });
//       let newdata = sortedData.map((el) => {
//         el.time = modifiedTime(el.time);
//         function modifiedTime(timing) {
//           const parts = timing.split(" - ");
//           const startTime = parts[0];
//           const endTime = parts[1];

//           // Converting start time to 12-hour format
//           const start = new Date(`2000-01-01T${startTime}`);
//           const startHours = start.getHours();
//           const startMinutes = start.getMinutes();
//           const formattedStartTime = `${startHours % 12 || 12}:${startMinutes
//             .toString()
//             .padStart(2, "0")}`;

//           // Converting end time to 12-hour format
//           const end = new Date(`2000-01-01T${endTime}`);
//           const endHours = end.getHours();
//           const endMinutes = end.getMinutes();
//           const formattedEndTime = `${endHours % 12 || 12}:${endMinutes
//             .toString()
//             .padStart(2, "0")}`;

//           // Determine AM/PM
//           const amPm = startHours < 12 ? "AM" : "PM";

//           return `${formattedStartTime} ${amPm} - ${formattedEndTime} ${amPm}`;
//         }
//         return el;
//       });
//       console.log("newdata response with time..", newdata);
//       if (newdata) {
//         setCancelledAppointments(newdata);
//         setAcceptReject(false);
//         setLoading(false);
//       }
//     } catch (error) {
//       console.log(error.message);
//     }
//   }

//   // useEffect(() => {
//   //   getAppointmentCancelledData();

//   // }, [acceptReject]);

//   const formattedDate = (date) => {
//     const dob = moment(date);
//     const formattedDob = dob.format("DD-MM-YYYY");
//     return formattedDob;
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         let response = await getCancelledReqWithDate(
//           newCancelSelectedDate,
//           uniqueId
//         );
//         let data = response.data;
//         console.log("upcomingreq with data", data);
//         setCancelledAppointments(data);
//       } catch (error) {
//         console.log(error.message);
//       }
//     };

//     if (newCancelSelectedDate) {
//       fetchData();
//     } else {
//       getAppointmentCancelledData();
//     }
//   }, [acceptReject, newCancelSelectedDate]);

//   if (loading)
//     return (
//       <>
//         <Loader />
//       </>
//     );
//   return (
//     <>
//       <Card
//         sx={{
//           padding: "1% 2% !important",
//           marginBottom: "10px",
//           border: "1px solid #D9D9D9",
//           borderRadius: "5px",
//           overflowY: "scroll",
//           height: "65vh",
//           boxShadow: "none",
//         }}
//         className="thecardbox"
//       >
//         {cancelledAppointments.map((el, id) => {
//           return (
//             <>
//               {CancelledPermission && (
//                 <Card
//                   sx={{
//                     padding: "0px 0%!important",
//                     marginBottom: "10px",
//                     border: "1px solid #D9D9D9",
//                     borderRadius: "5px",
//                     boxShadow: "none",
//                   }}
//                 >
//                   <Grid container spacing={1}>
//                     <Grid item xs={3}>
//                       <Box
//                         sx={{
//                           padding: "15px",
//                         }}
//                       >
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             color: "#D83F87",
//                             fontWeight: "bold",
//                             fontSize: "10px",
//                           }}
//                         >
//                           Appointment ID
//                         </Typography>
//                         <Typography
//                           variant="h6"
//                           sx={{ fontWeight: "bold", fontSize: "12px" }}
//                         >
//                           {el.appointmentId == null ? (
//                             <>No Appointment ID</>
//                           ) : (
//                             el.appointmentId
//                           )}
//                         </Typography>
//                         {/* <Box
//                   style={{
//                     background: "#00984F",
//                     padding: "10px",
//                     borderRadius: "6px",
//                     lineHeight: "0.5",
//                   }}
//                 >
//                   <Typography variant="caption" sx={{ color: "#fff" }}>
//                     {el.request}
//                   </Typography>
//                 </Box> */}
//                       </Box>
//                     </Grid>
//                     {/* <Divider orientation="vertical" flexItem /> */}
//                     <Grid item xs={7}>
//                       <Grid container spacing={1}>
//                         <Grid item xs={4}>
//                           <Box sx={{ padding: "15px" }}>
//                             <Typography
//                               variant="subtitle1"
//                               sx={{ fontWeight: "bold", fontSize: "12px" }}
//                             >
//                               {el.patientName}
//                             </Typography>
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                               <PhoneIcon style={{ fontSize: "12px" }} />
//                               <Typography
//                                 variant="caption"
//                                 sx={{ fontSize: "12px" }}
//                               >
//                                 {el.patientNmber === null ? (
//                                   <>No number</>
//                                 ) : (
//                                   el.patientNumber
//                                 )}
//                               </Typography>
//                             </Box>
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 gap: "10px",
//                                 paddingLeft: "20px",
//                               }}
//                             ></Box>
//                             <Box sx={{ textAlign: "center", width: "70%" }}>
//                               <Typography
//                                 sx={{
//                                   fontSize: "10px",
//                                   background: "#FFEFF9",
//                                   padding: "5px",
//                                   color: "gray",
//                                   borderRadius: "6px",
//                                   width: "100%",
//                                 }}
//                               >
//                                 {el.specialty}
//                               </Typography>
//                             </Box>
//                           </Box>
//                         </Grid>
//                         <Grid item xs={5}>
//                           <Box sx={{ padding: "15px" }}>
//                             <Typography
//                               variant="caption"
//                               sx={{
//                                 color: "#D83F87",
//                                 fontWeight: "bold",
//                                 fontSize: "10px",
//                               }}
//                             >
//                               Appointment Date
//                             </Typography>
//                             <Typography
//                               v4ant="subtitle1"
//                               sx={{ fontWeight: "bold", fontSize: "12px" }}
//                             >
//                               {formattedDate(el.date)}
//                             </Typography>
//                             <Box sx={{ marginTop: "15px" }}>
//                               <Typography
//                                 variant="caption"
//                                 sx={{
//                                   color: "#D83F87",
//                                   fontWeight: "bold",
//                                   fontSize: "10px",
//                                 }}
//                               >
//                                 Appointment Time
//                               </Typography>
//                               <Typography
//                                 variant="subtitle1"
//                                 sx={{ fontWeight: "bold", fontSize: "12px" }}
//                               >
//                                 {el.time}
//                               </Typography>
//                             </Box>
//                           </Box>
//                         </Grid>

//                         <Grid item xs={3}>
//                           <Box
//                             sx={{
//                               padding: "15px",
//                             }}
//                           >
//                             <Typography
//                               variant="caption"
//                               sx={{
//                                 color: "#D83F87",
//                                 fontWeight: "bold",
//                                 fontSize: "10px",
//                               }}
//                             >
//                               Remarks
//                             </Typography>{" "}
//                             <br />
//                             <Typography
//                               variant="caption"
//                               sx={{ fontSize: "12px" }}
//                             >
//                               {el.remark === "" ? <>No Remarks</> : el.remark}
//                             </Typography>
//                           </Box>
//                         </Grid>
//                       </Grid>
//                     </Grid>
//                     {/* <Divider orientation="vertical" flexItem /> */}

//                     <Grid item xs={2} sx={{ backgroundColor: "#F5F5F5" }}>
//                       <Box sx={{ pt: "40px" }}>
//                         <Typography>This appointment was cancelled.</Typography>
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Card>
//               )}
//             </>
//           );
//         })}
//       </Card>

//       {/* -----------------------------------------Table for mobile screen------------------------------ */}
//       <Card
//         sx={{
//           padding: "1% 2% !important",
//           marginBottom: "10px",
//           border: "1px solid #D9D9D9",
//           borderRadius: "5px",
//           overflowY: "scroll",
//           height: "65vh",
//           boxShadow: "none",
//         }}
//         className="mobilescreencard"
//       >
//         {cancelledAppointments.map((el, id) => {
//           return (
//             <>
//               {CancelledPermission && (
//                 <Card
//                   sx={{
//                     padding: "0px 0%!important",
//                     marginBottom: "10px",
//                     border: "1px solid #D9D9D9",
//                     borderRadius: "5px",
//                     boxShadow: "none",
//                   }}
//                   className="mobilecontentcard"
//                 >
//                   <Grid container spacing={1}>
//                     <Grid item xs={4}>
//                       <Typography className="appointmentid" variant="h6">
//                         {el.appointmentId
//                           ? el.appointmentId
//                           : "No AppointmentID"}
//                       </Typography>
//                       <Typography className="dateheading" variant="caption">
//                         Date
//                       </Typography>
//                       <Typography className="date" variant="subtitle1">
//                         {formattedDate(el.date)}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={4}>
//                       <Typography className="speciality">
//                         {el.specialty}
//                       </Typography>
//                       <Typography variant="caption" className="timeheading">
//                         Time
//                       </Typography>
//                       <Typography variant="subtitle1" className="time">
//                         {el.time}
//                       </Typography>
//                     </Grid>
//                     <Grid
//                       sx={{ backgroundColor: "#F5F5F5!important" }}
//                       item
//                       xs={4}
//                     >
//                       <Typography sx={{ fontSize: "12px", mt: "10px" }}>
//                         This appointment was canceled.
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Card>
//               )}
//             </>
//           );
//         })}
//       </Card>
//     </>
//   );
// };
// combined Cancelled and Unattended tab
export const ClinicCancelledTable = ({
  setCancelledAppointments,
  cancelledAppointments,
  newCancelSelectedDate,
}) => {
  const [date, setDate] = useState(new Date());
  const [acceptReject, setAcceptReject] = useState(false);
  const [combinedAppointments, setCombinedAppointments] = useState([]);
  const token = JSON.parse(localStorage.getItem("token"));
  const username = token?.username;
  const uniqueId = token?.uniqueId;
  const { permissionsData, loading, setLoading } = useContext(Permissions);

  let clinicPermissionsModule = permissionsData?.filter(
    (item) => item.module === "appointment"
  );
  let clinicPermissions =
    clinicPermissionsModule && clinicPermissionsModule[0]?.permissions;

  let CancelledPermission = clinicPermissions?.find(
    (item) => item.action === "Cancelled"
  )?.permission;

  let currentdate = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let entiredate = `${year}-${month > 9 ? month : "0" + month}-${
    currentdate > 9 ? currentdate : "0" + currentdate
  }`;
  console.log("entiredate..", entiredate);

  // Function to format time
  const modifiedTime = (timing) => {
    const parts = timing.split(" - ");
    const startTime = parts[0];
    const endTime = parts[1];

    // Converting start time to 12-hour format
    const start = new Date(`2000-01-01T${startTime}`);
    const startHours = start.getHours();
    const startMinutes = start.getMinutes();
    const formattedStartTime = `${startHours % 12 || 12}:${startMinutes
      .toString()
      .padStart(2, "0")}`;

    // Converting end time to 12-hour format
    const end = new Date(`2000-01-01T${endTime}`);
    const endHours = end.getHours();
    const endMinutes = end.getMinutes();
    const formattedEndTime = `${endHours % 12 || 12}:${endMinutes
      .toString()
      .padStart(2, "0")}`;

    // Determine AM/PM
    const amPm = startHours < 12 ? "AM" : "PM";

    return `${formattedStartTime} ${amPm} - ${formattedEndTime} ${amPm}`;
  };

  // Function to get cancelled appointments
  async function getAppointmentCancelledData() {
    setLoading(true);
    try {
      const response = await getClinicAppointrequestCancelled(uniqueId);
      console.log("cancelled response....", response.data);
      let data = response.data || [];

      // Format time for cancelled appointments
      let formattedData = data.map((el) => ({
        ...el,
        time: modifiedTime(el.time),
        appointmentStatus: "Cancelled", // Ensure status is set
      }));

      return formattedData;
    } catch (error) {
      console.log("Error fetching cancelled appointments:", error.message);
      return [];
    }
  }

  // Function to get unattended appointments
  const getUnattendedAppointmentRequests = async () => {
    try {
      const response = await getUnattendedAppointmentRequestData(uniqueId);
      console.log("unattended response....", response.data);
      let data = response.data || [];

      // Format time for unattended appointments
      let formattedData = data.map((el) => ({
        ...el,
        time: modifiedTime(el.time),
        appointmentStatus: "Unattended", // Ensure status is set
      }));

      return formattedData;
    } catch (error) {
      console.log("Error fetching unattended appointments:", error.message);
      return [];
    }
  };

  // Function to combine and sort both datasets
  const getCombinedAppointments = async () => {
    setLoading(true);
    try {
      // Fetch both cancelled and unattended appointments
      const [cancelledData, unattendedData] = await Promise.all([
        getAppointmentCancelledData(),
        getUnattendedAppointmentRequests(),
      ]);

      // Combine both arrays
      const combinedData = [...cancelledData, ...unattendedData];

      // Sort by date (descending) and then by time (ascending)
      let sortedData = combinedData.sort((a, b) => {
        // Sort by date (descending)
        if (a.date > b.date) return -1;
        if (a.date < b.date) return 1;

        // Sort by time (ascending)
        const timeA = a.time.split(" - ")[0];
        const timeB = b.time.split(" - ")[0];
        return (
          new Date(`1970/01/01 ${timeB}`) - new Date(`1970/01/01 ${timeA}`)
        );
      });

      console.log("combined and sorted data:", sortedData);
      setCombinedAppointments(sortedData);
      setCancelledAppointments(sortedData); // Keep this for backward compatibility
      setLoading(false);
    } catch (error) {
      console.log("Error combining appointments:", error.message);
      setLoading(false);
    }
  };

  // Function to get appointments by date
  const getAppointmentsByDate = async (selectedDate) => {
    setLoading(true);
    try {
      // You might need to create similar functions for unattended appointments by date
      // For now, I'll assume you have a similar function or modify the existing one
      const cancelledResponse = await getCancelledReqWithDate(
        newCancelSelectedDate,
        uniqueId
      );

      // If you have a similar function for unattended by date, use it here
      // const unattendedResponse = await getCustomerUnattendedReqWithDate(selectedDate, username);

      let cancelledData = cancelledResponse.data || [];
      // let unattendedData = unattendedResponse.data || []; // Uncomment when available

      // For now, just using cancelled data. Add unattended when API is available
      const combinedData = [...cancelledData]; // Add ...unattendedData when available

      console.log("appointments by date", combinedData);
      setCombinedAppointments(combinedData);
      setCancelledAppointments(combinedData);
      setLoading(false);
    } catch (error) {
      console.log("Error fetching appointments by date:", error.message);
      setLoading(false);
    }
  };

  const formattedDate = (date) => {
    const dob = moment(date);
    const formattedDob = dob.format("DD-MM-YYYY");
    return formattedDob;
  };

  // Function to get status color and text
  const getStatusDisplay = (status) => {
    switch (status?.toLowerCase()) {
      case "cancelled":
        return {
          text: "This appointment was cancelled.",
          bgColor: "#FFF2F2",
          textColor: "#D83F87",
        };
      case "unattended":
        return {
          text: "This appointment was unattended.",
          bgColor: "#FFF9E6",
          textColor: "#E67E22",
        };
      default:
        return {
          text: "Status unknown.",
          bgColor: "#F5F5F5",
          textColor: "#666666",
        };
    }
  };

  useEffect(() => {
    if (newCancelSelectedDate) {
      getAppointmentsByDate(newCancelSelectedDate);
    } else {
      getCombinedAppointments();
    }
  }, [acceptReject, newCancelSelectedDate]);

  if (loading)
    return (
      <h1>
        <Loader />
      </h1>
    );

  const appointmentsToDisplay =
    combinedAppointments.length > 0
      ? combinedAppointments
      : cancelledAppointments;

  return (
    <>
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "0.5px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
          boxShadow: "none",
        }}
        className="desktopscreencard"
      >
        {appointmentsToDisplay.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Typography variant="h6" color="textSecondary">
              No Cancelled or Unattended appointments
            </Typography>
          </div>
        ) : (
          <>
            {appointmentsToDisplay.map((el, id) => {
              const statusDisplay = getStatusDisplay(el.appointmentStatus);
              return (
                <>
                  {CancelledPermission && (
                    <Card
                      sx={{
                        padding: "0px 0%!important",
                        marginBottom: "10px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "5px",
                        boxShadow: "none",
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={3}>
                          <Box
                            sx={{
                              padding: "15px",
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#D83F87",
                                fontWeight: "bold",
                                fontSize: "10px",
                              }}
                            >
                              Appointment ID
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold", fontSize: "12px" }}
                            >
                              {el.appointmentId == null ? (
                                <>No Appointment ID</>
                              ) : (
                                el.appointmentId
                              )}
                            </Typography>
                            {/* <Box
                  style={{
                    background: "#00984F",
                    padding: "10px",
                    borderRadius: "6px",
                    lineHeight: "0.5",
                  }}
                >
                  <Typography variant="caption" sx={{ color: "#fff" }}>
                    {el.request}
                  </Typography>
                </Box> */}
                            <Box sx={{ marginTop: "10px" }}>
                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  background: statusDisplay.bgColor,
                                  padding: "4px 8px",
                                  color: statusDisplay.textColor,
                                  borderRadius: "4px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                }}
                              >
                                {el.appointmentStatus?.toUpperCase()}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}
                        <Grid item xs={7}>
                          <Grid container spacing={1}>
                            <Grid item xs={4}>
                              <Box sx={{ padding: "15px" }}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: "bold", fontSize: "12px" }}
                                >
                                  {el.patientName}
                                </Typography>
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <PhoneIcon style={{ fontSize: "12px" }} />
                                  <Typography
                                    variant="caption"
                                    sx={{ fontSize: "12px" }}
                                  >
                                    {el.patientNmber === null ? (
                                      <>No number</>
                                    ) : (
                                      el.patientNumber
                                    )}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    gap: "10px",
                                    paddingLeft: "20px",
                                  }}
                                ></Box>
                                <Box sx={{ textAlign: "center", width: "70%" }}>
                                  <Typography
                                    sx={{
                                      fontSize: "10px",
                                      background: "#FFEFF9",
                                      padding: "5px",
                                      color: "gray",
                                      borderRadius: "6px",
                                      width: "100%",
                                    }}
                                  >
                                    {el.specialty}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={5}>
                              <Box sx={{ padding: "15px" }}>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "#D83F87",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                  }}
                                >
                                  Appointment Date
                                </Typography>
                                <Typography
                                  v4ant="subtitle1"
                                  sx={{ fontWeight: "bold", fontSize: "12px" }}
                                >
                                  {formattedDate(el.date)}
                                </Typography>
                                <Box sx={{ marginTop: "15px" }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#D83F87",
                                      fontWeight: "bold",
                                      fontSize: "10px",
                                    }}
                                  >
                                    Appointment Time
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {el.time}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>

                            <Grid item xs={3}>
                              <Box
                                sx={{
                                  padding: "15px",
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: "#D83F87",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                  }}
                                >
                                  Remarks
                                </Typography>{" "}
                                <br />
                                <Typography
                                  variant="caption"
                                  sx={{ fontSize: "12px" }}
                                >
                                  {el.remark === "" ? (
                                    <>No Remarks</>
                                  ) : (
                                    el.remark
                                  )}
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* <Divider orientation="vertical" flexItem /> */}

                        <Grid
                          item
                          xs={2}
                          sx={{ backgroundColor: statusDisplay.bgColor }}
                        >
                          <Box sx={{ pt: "50px" }}>
                            <Typography
                              fontSize="14px"
                              sx={{ color: statusDisplay.textColor }}
                            >
                              {statusDisplay.text}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                </>
              );
            })}
          </>
        )}
      </Card>

      {/* ----------------------------------Table for mobile screen--------------------------- */}
      <Card
        sx={{
          padding: "1% 2% !important",
          marginBottom: "10px",
          border: "1px solid #D9D9D9",
          borderRadius: "5px",
          overflowY: "scroll",
          height: "65vh",
        }}
        className="mobilescreencard"
      >
        {appointmentsToDisplay.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Typography variant="h6" color="textSecondary">
              No Cancelled or Unattended appointments
            </Typography>
          </div>
        ) : (
          <>
            {appointmentsToDisplay.map((el, id) => {
              const statusDisplay = getStatusDisplay(el.appointmentStatus);
              return (
                <>
                  {CancelledPermission && (
                    <Card
                      key={el.id}
                      sx={{
                        padding: "0px 0%!important",
                        marginBottom: "10px",
                        border: "1px solid #D9D9D9",
                        borderRadius: "5px",
                      }}
                      className="mobilecontentcard"
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <Typography className="appointmentid" variant="h6">
                            {el.appointmentId
                              ? el.appointmentId
                              : "No AppointmentID"}
                          </Typography>
                          <Typography className="dateheading" variant="caption">
                            Date
                          </Typography>
                          <Typography className="date" variant="subtitle1">
                            {formattedDate(el.date)}
                          </Typography>
                          {/* Status Badge for mobile */}
                          <Typography
                            sx={{
                              fontSize: "9px",
                              background: statusDisplay.bgColor,
                              padding: "2px 6px",
                              color: statusDisplay.textColor,
                              borderRadius: "3px",
                              fontWeight: "bold",
                              marginTop: "5px",
                              display: "inline-block",
                            }}
                          >
                            {el.appointmentStatus?.toUpperCase()}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="speciality">
                            {el.specialty}
                          </Typography>
                          <Typography variant="caption" className="timeheading">
                            Time
                          </Typography>
                          <Typography variant="subtitle1" className="time">
                            {el.time}
                          </Typography>
                        </Grid>
                        <Grid
                          sx={{
                            backgroundColor: `${statusDisplay.bgColor}!important`,
                          }}
                          item
                          xs={4}
                        >
                          <Typography
                            sx={{
                              fontSize: "12px",
                              mt: "10px",
                              color: statusDisplay.textColor,
                            }}
                          >
                            {statusDisplay.text}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Card>
                  )}
                </>
              );
            })}
          </>
        )}
      </Card>
    </>
  );
};
